const e = { aria_label: "Søg", clear: "Ryd", placeholder_article: "", placeholder_header: "Søg efter artikler" }, a = {
  searcher: e
};
export {
  a as default,
  e as searcher
};
//# sourceMappingURL=help-center-articles-search30.js.map
